import { Routes } from '@angular/router';

export const Reporting_Routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/reporting/reporting.module').then(m => m.ReportingModule),
  },
];
